// Vendor-defined formats; change them only to match these docs:
// https://claude.com/docs/connectors/building/directory-vs-custom (install links)
// https://claude.com/docs/connectors/custom/add-unlisted
// https://claude.com/docs/plugins/admin
// https://developers.openai.com/api/docs/guides/custom-mcp-server
// https://cursor.com/docs/mcp/install-links
export const CLAUDE_URLS = {
  connectors: 'https://claude.ai/customize/connectors',
  orgConnectors: 'https://claude.ai/admin-settings/connectors',
  plugins: 'https://claude.ai/customize/plugins',
  orgPluginsAndSkills: 'https://claude.ai/admin-settings/skills?tab=inventory',
} as const;

export const CHATGPT_URLS = {
  plugins: 'https://chatgpt.com/plugins',
} as const;

// ChatGPT's menu names for adding a server; `**…**` marks an exact label.
export const CHATGPT_ADD_SERVER_STEPS = {
  open: 'Open **Plugins** in ChatGPT.',
  add: 'Click **+**, then **Add custom MCP server**.',
  nameAndUrl: (name: string) =>
    `Name it **${name}**. Under **Connection**, paste the server URL.`,
  create: (signIn: boolean) =>
    signIn
      ? 'Set **Authentication** to **OAuth** and leave the client ID and secret empty. Tick **I understand and want to continue**, then click **Create as a plugin**.'
      : 'Set **Authentication** to **No authentication**, tick **I understand and want to continue**, then click **Create as a plugin**.',
} as const;

const addCustomConnector = (base: string, name: string, serverUrl: string) =>
  `${base}?modal=add-custom-connector&connectorName=${encodeURIComponent(
    name,
  )}&connectorUrl=${encodeURIComponent(serverUrl)}`;

/** Prefills Claude's Add custom connector dialog; nothing is added until the
 * person confirms it there. */
export const claudeInstallLink = (name: string, serverUrl: string) =>
  addCustomConnector(CLAUDE_URLS.connectors, name, serverUrl);

export const claudeOrgInstallLink = (name: string, serverUrl: string) =>
  addCustomConnector(CLAUDE_URLS.orgConnectors, name, serverUrl);

const toBase64 = (text: string) => {
  let binary = '';
  new TextEncoder().encode(text).forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

export interface CursorServerConfig {
  url: string;
  headers?: Record<string, string>;
}

// Base64 can contain "+", which a query string would otherwise read as a space.
const cursorInstallQuery = (name: string, config: CursorServerConfig) =>
  `name=${encodeURIComponent(name)}&config=${encodeURIComponent(
    toBase64(JSON.stringify(config)),
  )}`;

export const cursorInstallLink = (name: string, config: CursorServerConfig) =>
  `cursor://anysphere.cursor-deeplink/mcp/install?${cursorInstallQuery(name, config)}`;

/** For browsers that won't open cursor:// links directly. */
export const cursorWebInstallLink = (
  name: string,
  config: CursorServerConfig,
) => `https://cursor.com/link/mcp/install?${cursorInstallQuery(name, config)}`;
